import React from 'react';

import { HN_SKJEMA_FRONTEND_RESOURCES } from 'src/constants/constants';
import { useLogin } from 'src/hooks/useLogin';
import { useResources } from 'src/resources';
import { useAppDispatch, useAppSelector } from 'src/store/reducers';
import { dismissAnonymousMessage } from 'src/store/reducers/uiSlice';

import type { HNSkjemaFrontend } from 'src/types/Resources';

import Modal from '@helsenorge/designsystem-react/components/Modal';
import NotificationPanel from '@helsenorge/designsystem-react/components/NotificationPanel';

import { isAuthorized } from '@helsenorge/framework-utils/hn-authorize';

export const AnonomousSkjemaLightbox = (): React.JSX.Element | null => {
  const dispatch = useAppDispatch();
  const showAnonymousSkjemaLightbox = useAppSelector(state => state.refero.ui.showAnonymousSkjemaLightbox);
  const resources = useResources<HNSkjemaFrontend>(HN_SKJEMA_FRONTEND_RESOURCES);
  const skjemaLoginButton = resources?.skjemaLoginButton;
  const formCancel = resources?.formCancel;
  const skjemaLoginMessageAuthenticationRequirementRequired = resources?.skjemaLoginMessageAuthenticationRequirementRequired;
  const { login } = useLogin();

  const handleHideAnonymousSkjemaLightbox = (): void => {
    dispatch(dismissAnonymousMessage());
  };

  return showAnonymousSkjemaLightbox && !isAuthorized() ? (
    <Modal
      testId="anonymous-skjema-lightbox"
      title={'Logg inn'}
      primaryButtonText={skjemaLoginButton}
      secondaryButtonText={formCancel}
      onSuccess={(): void => {
        handleHideAnonymousSkjemaLightbox();
        login();
      }}
      onClose={handleHideAnonymousSkjemaLightbox}
    >
      <NotificationPanel variant="info" testId="notification-panel-anonymous-skjema-lightbox-info">
        {skjemaLoginMessageAuthenticationRequirementRequired}
      </NotificationPanel>
    </Modal>
  ) : null;
};
